<template>
  <component :is="type" />
</template>

<script>
import Supplier from 'components/monitor-dimension/supplier'; // 供应商白名单
import RawAccessory from 'components/monitor-dimension/raw-accessory'; // 原辅料检验报告
import Product from 'components/monitor-dimension/product'; // 成品检验报告
import DrugStock from 'components/monitor-dimension/drug-stock'; // 药品生产入库
import Environment from 'components/monitor-dimension/environment'; // 环境数据
import EnvironmentDetail from 'components/monitor-dimension/environment-detail';
import Other from 'components/monitor-dimension/other'; // 其他数据

export default {
  data() {
    return {
      type: 'Product'
    };
  },
  mounted() {
    this.type = this.$route.params.type;
  },
  watch: {
    $route() {
      this.type = this.$route.params.type;
      document.querySelector('.content-container').scrollTop = 0;
    }
  },
  components: {
    Supplier,
    RawAccessory,
    Product,
    DrugStock,
    Environment,
    EnvironmentDetail,
    Other
  }
};
</script>
